import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";
import { formQKeys } from "./queryKeys";
import { ServiceFormConfiguration } from "@customTypes/forms";

export const useGetFormConfig = (serviceId: string) => {
  return useQuery({
    queryKey: formQKeys.config(serviceId),
    queryFn: async () => {
      const { data } = await api.get<ServiceFormConfiguration>(`form-configurations/${serviceId}`);
      return data;
    },
    enabled: !!serviceId,
    retry: false, // If no form exists, it returns 404, which is expected
  });
};
